// Admin: Referrals (decision 55, 13 Oct; docs/referrals-spec.md section 4), owner and admin only: who referred
// whom and what's owed (Introductions, /admin/referrals), who can refer what (Who can refer,
// /admin/referrals/who) and each product's offer (Offers, /admin/referrals/offers). No board draws it: the
// admin boards' look, with the shared pieces in src/admin/ui and the words in src/admin/referrals/words.js.
//
// Support and hosts never see it: the menu leaves it out and the shell refuses the address (shell/routes.js),
// and the database gives anyone but owner and admin at 2-step login nothing anyway. At 1440 the tables are
// the other admin screens' width; under 760 every table is a card per row with the same buttons (Adam's
// answer 5 of 4 Oct).
import { useMemo } from 'react'
import { useLocation } from '../../lib/router.jsx'
import { Loading, PageHeader, Problem, Tabs, useAdmin, useLoad, adminPath } from '../ui/index.js'
import { REF } from '../referrals/words.js'
import { loadLedger, loadOffers, productsWithOffers } from '../referrals/data.js'
import { Introductions } from '../referrals/Introductions.jsx'
import { WhoCanRefer } from '../referrals/WhoCanRefer.jsx'
import { Offers } from '../referrals/Offers.jsx'
import '../../styles/admin-referrals.css'

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export default function Referrals({ route }) {
  const { api, products } = useAdmin()
  const tab = route.params.tab || 'introductions'
  const query = useLocation().query
  const line = query.get('line')
  const product = query.get('product')
  const offers = useLoad(() => loadOffers(api), [api])
  // the ledger only for Introductions; read again each time the tab opens
  const ledger = useLoad(() => (tab === 'introductions' ? loadLedger(api) : Promise.resolve(null)), [api, tab])
  const withOffers = useMemo(() => productsWithOffers(products, offers.data || []), [products, offers.data])

  return (
    <div className="rf-page">
      <PageHeader title={REF.title} lede={REF.lede} />
      <Tabs label={REF.tabsLabel} current={tab} items={[
        { key: 'introductions', label: REF.tabs.introductions, to: adminPath.referrals() },
        { key: 'who', label: REF.tabs.who, to: adminPath.referralsWho() },
        { key: 'offers', label: REF.tabs.offers, to: adminPath.referralsOffers() },
      ]} />
      {tab === 'introductions' && (
        <Introductions ledger={ledger} offers={offers.data || []} products={withOffers}
          focusLine={line && UUID.test(line) ? line.toLowerCase() : null} />
      )}
      {tab === 'who' && (offers.data
        ? <WhoCanRefer products={withOffers} focusProduct={product && UUID.test(product) ? product.toLowerCase() : null} />
        : offers.status === 'loading' ? <Loading /> : <Problem error={offers.error} onRetry={offers.reload} />)}
      {tab === 'offers' && <Offers offers={offers} products={products} />}
    </div>
  )
}
